const MEDIA_URL = process.env.REACT_APP_IMAGE_URL;

const routes = {
  all: "*",
  homepage: "/",
  login: "/login",
  sync: "/sync",
  browserCompatibility: "/check-browser-compatibility",

  dashboard: "/dashboard",
  company: "/company",
  goverment: "/goverment",
  siphoningSummary: "/siphoning-summary",
  taskSummaryNotes: "/item-summary-notes",
  reportItemDetails: "/report-items-details",
  companyItemList: "/company-item-lists",
  companyItemDetails: "/company-item-details",
  companyReportStages: "/company/sub-items",
  companyReportStage: "/company/sub-item-details",
  reports: "/reports",
  reportsList: "/report-lists",
};

const apiEndpoints = {
  media: "/media",
  login: "/login",
  logout: "/user/logout",
  getLocation: "/get-directions",
  restaurantDetails: "/user/restaurant-item",
  restaurantReports: "/user/restaurant-item?action=report",
  submitRestaurantDetails: "/user/item-report",
  addRestaurantTaskNotes: "/user/add-notes",
};

const notAllowHeader = [];

const notAllowFooter = [];

const headerChildPages = [];

const companyNames = {
  fog: "fog",
};

const companyConfig = {
  fog_test: {
    name: "fog",
    server: "test",
    checkBrowser: true,
    pages: [
      routes.dashboard,
      routes.company,
      routes.siphoningSummary,
      routes.taskSummaryNotes,
      routes.reportItemDetails,

      routes.companyItemList,
      routes.companyItemDetails,
      routes.companyReportStages,
      routes.companyReportStage,
      routes.reports,
    ],
  },
  fog_copy: {
    name: "fog",
    server: "copy",
    checkBrowser: true,
    pages: [
      routes.dashboard,
      routes.company,
      routes.siphoningSummary,
      routes.taskSummaryNotes,
      routes.reportItemDetails,

      routes.companyItemList,
      routes.companyItemDetails,
      routes.companyReportStages,
      routes.companyReportStage,
      routes.reports,
    ],
  },
  fog: {
    name: "fog",
    server: "live",
    checkBrowser: true,
    pages: [
      routes.dashboard,
      routes.company,
      routes.siphoningSummary,
      routes.taskSummaryNotes,
      routes.reportItemDetails,

      routes.companyItemList,
      routes.companyItemDetails,
      routes.companyReportStages,
      routes.companyReportStage,
      routes.reports,
    ],
  },
};

const SYNC_TYPE = {
  SYNC: "sync",
  LOGIN: "login",
  BLOCK: "block",
  LOGOUT: "logout",
  UPLOAD: "upload",
  ISNMONTH: "isNMonth",
  FINALUPLOAD: "finalUpload",
  AUTOREFRESH: "autoRefresh",
  BROWSERLOGOUT: "browserLogout",
};

export {
  MEDIA_URL,
  routes,
  apiEndpoints,
  notAllowHeader,
  notAllowFooter,
  companyNames,
  companyConfig,
  headerChildPages,
  SYNC_TYPE,
};
